var _a;
import { immerable } from 'immer';
var WorkTemplateGroups = /** @class */ (function () {
    function WorkTemplateGroups(obj) {
        this[_a] = true;
        this.templateGroupsMap = obj == null ? new Map() : new Map(Object.entries(obj));
    }
    Object.defineProperty(WorkTemplateGroups.prototype, "allTemplates", {
        // 全てのワークテンプレート
        get: function () {
            return Array.from(this.templateGroupsMap.values()).flatMap(function (groups) {
                return groups.flatMap(function (_b) {
                    var workTemplates = _b.workTemplates;
                    return workTemplates;
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkTemplateGroups.prototype, "selectedTemplates", {
        // 選択したワークテンプレート
        get: function () {
            return this.allTemplates.filter(function (_b) {
                var selected = _b.selected;
                return selected;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkTemplateGroups.prototype, "selectedCount", {
        // 選択したワークテンプレートの数
        get: function () {
            return this.selectedTemplates.length;
        },
        enumerable: false,
        configurable: true
    });
    // ワークテンプレートグループを取得
    WorkTemplateGroups.prototype.get = function (key) {
        return this.templateGroupsMap.get(key);
    };
    // ワークテンプレートグループを設定
    WorkTemplateGroups.prototype.set = function (key, templateGroups) {
        this.templateGroupsMap.set(key, templateGroups);
    };
    // ワークテンプレートグループのMapをクリアー
    WorkTemplateGroups.prototype.clear = function () {
        this.templateGroupsMap.clear();
    };
    // オブジェクト化
    WorkTemplateGroups.prototype.toObject = function () {
        return Object.fromEntries(this.templateGroupsMap);
    };
    return WorkTemplateGroups;
}());
export { WorkTemplateGroups };
_a = immerable;
